import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, SubmissionError, Field } from 'redux-form';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

import { login } from 'actions/authActions';
import { validateLogins } from 'validation';
import LoginFieldsGroup from './loginForm/LoginFieldsGroup';
import ForgotPasswordForm from './loginForm/ForgotPasswordForm';
import { Modal } from 'components/common';
import classes from './LoginForm.module.scss';
import SupportPhone from '../../../components/common/SupportPhone';
import HelpControls from '../HelpControls/HelpControls';
import { Help } from "../../../components/flink-play";

import { withRouter } from 'react-router-dom';


const StyledHelpWrapper = styled.div`
  font-family: 'Roboto';
  font-weight: initial
`;

class LoginForm extends Component {
  state = {
    forgotPasswordOpened: false,
    familyTeam: true,
  };

  async componentDidMount() {
    //const { initialValues, handleSubmit, family } = this.props;
    const { initialValues, handleSubmit } = this.props;

    if (this.props.location.pathname === '/login') {
      document.body.classList.add('login-page');
    }

    if (initialValues && initialValues.autoLogin) {
      handleSubmit(this.submitHandler.bind(this, initialValues))();
    }

  }

/*  componentDidUpdate(prevState) {
    const { familyTeam } = this.state;
    if (prevState?.familyTeam !== familyTeam) {
      this.handlerChangeTeamType();
    }
}*/
componentWillUnmount() {
  document.body.classList.remove('login-page');
}


componentDidUpdate(prevProps) {
  const hadFamily = !!(prevProps.family?.id || prevProps.family?.members?.length);
  const hasFamily = !!(this.props.family?.id || this.props.family?.members?.length);

  if (!hadFamily && hasFamily && this.state.familyTeam !== true) {
    this.setState({ familyTeam: true });
  }
}

  submitHandler = async (values, dispatch) => {
    const { learningCenter, login } = this.props;

    if (values.username2 || values.username3) {
      values.isTeam = true;
    } else {
      values.isTeam = false;
    }

    const learningCenterId = (learningCenter && learningCenter._id) || null;

    const result = await login({ ...values, learningCenterId });

    if (!result.success) {
      this.props.onError && this.props.onError(result.data);

      if (result.data && result.data.errors) {
        throw new SubmissionError(result.data.errors);
      }
    } else if (learningCenter?.config?.offline) {
      values.username && localStorage.setItem('flc-username', values.username);
      values.username2 &&
        localStorage.setItem('flc-username2', values.username2);
      values.username3 &&
        localStorage.setItem('flc-username3', values.username3);
    }
  };

  setForgotPasswordOpened = (state) => {
    this.setState({ forgotPasswordOpened: state });
  };

  /*onChangeTeamType = () => {
    this.setState(
      { familyTeam: !this.state.familyTeam },
      ()=>
      {
        if (!this.state.familyTeam)
          localStorage.setItem('familyTeam',`${this.state.familyTeam}`);
        else localStorage.removeItem('familyTeam');
        this.props.handleChangeTeamType();
        console.log('familyTeam: ', this.state.familyTeam);
      }
    );    
  };*/

  onChangeTeamType = (e) => {
    const nextFamilyTeam = !e.target.checked;

    this.setState({ familyTeam: nextFamilyTeam }, () => {
      this.props.handleChangeTeamType(nextFamilyTeam);
      console.log('[LoginForm][familyTeam][change]', { nextFamilyTeam });
    });
  }


  renderLogins = () => {
    const { learningCenter, family, product, instructionsData } = this.props;

    const allLoginsFields = !!learningCenter;
    console.log('LoginForm product: ',product);
    console.log('LoginForm learningCenter: ',learningCenter)
    return (
      <div className={classes.loginsWrapper}>
        <LoginFieldsGroup 
          primary 
          //noTitle={!allLoginsFields || product?.onePerson} 
          noTitle={product?.onePerson || !allLoginsFields} 
          family={family}
          learningCenter={learningCenter} 
          product={product}
          instructionsData={instructionsData}
        />

        {allLoginsFields && !product?.onePerson && (
          <>
            <LoginFieldsGroup number="2" family={family} />
            <LoginFieldsGroup number="3" family={family} />
          </>
        )}
      </div>
    );
  };

  renderLanguages = () => {
    const { availableLocales, onChangeLocale, lang: currentLang } = this.props;

    return (
      <div className={classes.radioWrapper}>
        {availableLocales.length === 1
          ? null
          : availableLocales.map((locale) => {
              const checked = locale.code === currentLang.code;

              return (
                <label
                  className={classnames(classes.radioLabel, {
                    [classes.checked]: checked,
                  })}
                  key={locale._id}
                >
                  <Field
                    name="lang"
                    checked={checked}
                    component="input"
                    type="radio"
                    value={locale.code}
                    onChange={onChangeLocale}
                  />{' '}
                  {locale.displayName}
                </label>
              );
            })}
      </div>
    );
  };

  render() {
    const {
      handleSubmit,
      // pristine,
      submitting,
      translate,
      learningCenter,
      family,
      help,
      product,
    } = this.props;

    //const { forgotPasswordOpened } = this.state;
    //const { forgotPasswordOpened, /*familyTeam*/ } = this.state;
    const { forgotPasswordOpened, familyTeam } = this.state;

    if (!translate) return null;

    return (
      <>
        <form
          className={classes.loginForm}
          autoComplete="off"
          onSubmit={handleSubmit(this.submitHandler)}
        >
          <div className={classes.formContent}>
            {!product?.onePerson && this.renderLanguages()}
            {this.renderLogins()}
          </div>

          <div className={classes.buttonsWrapper}>
            <button
              className={classes.button + ' ' + classes.purple}
              disabled={submitting}
              type="submit"
            >
              {translate(104, 'Login')}
            </button>
            {/*
            {(!product?.onePerson && !(!localStorage.getItem('familyID') && !family.members.length)) && 
            <div className={classes.checkboxWrapper}>
              Teams
              <input
                type="checkbox"
                checked={!familyTeam}
                onChange={this.onChangeTeamType}
              />
            </div>
            */}

           {(!product?.onePerson &&
            !(!localStorage.getItem('familyID') && !family.members.length) &&
            learningCenter?.multiFamilyTeam) && (
            <label
              htmlFor="mf-team"
              className={classnames(classes.checkboxWrapper, classes.brandBlue)}
            >
              <input
                id="mf-team"
                type="checkbox"
                checked={!familyTeam}
                onChange={this.onChangeTeamType}
                className={classes.checkboxInput}
              />
              <span className={classes.checkboxText}>
                {translate(2921, 'Multi-family team')}
              </span>
            </label>
          )}
            

            {/* (!learningCenter || (!learningCenter.config.offline && !family.id)) */}
            {!learningCenter && (
              <button
                className={classes.button + ' ' + classes.blue}
                type="button"
                onClick={() => this.setForgotPasswordOpened(true)}
              >
                {translate(105, 'Forgot Password')}
              </button>
            )}

            {!product?.onePerson && 
            <div className={classes.helpAndPhoneWrapper}>
              {!!learningCenter && (<HelpControls />)}
              {!learningCenter?.config?.noSupportPhone && (
                <SupportPhone className={classes.phone} />
              )}
            </div>
            }
          
          </div>
        </form>

        {help && (
          <StyledHelpWrapper>
            <Help />
          </StyledHelpWrapper>
        )}

        <Modal
          on={forgotPasswordOpened}
          toggle={() => this.setForgotPasswordOpened(false)}
        >
          <ForgotPasswordForm
            translate={translate}
            onSuccess={() => this.setForgotPasswordOpened(false)}
          />
        </Modal>
      </>
    );
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  onChangeLocale: PropTypes.func.isRequired,
  lang: PropTypes.object,
  availableLocales: PropTypes.array.isRequired,
  family: PropTypes.object.isRequired,
  product: PropTypes.object,
  instructionsData: PropTypes.object,
  familyTeam: PropTypes.bool,
  handleChangeTeamType: PropTypes.func.isRequired,

};

const mapStateProps = ({ status, flinkPlay }) => ({
  lang: status.lang,
  translate: status.translate,
  help: flinkPlay.help,
});

export default compose(
  withRouter,
  connect(mapStateProps, { login }),
  reduxForm({
    form: 'loginForm',
    validate: validateLogins,
  })
)(LoginForm);
